import { render, staticRenderFns } from "./RouteErrorTooltip.vue?vue&type=template&id=72eb1140&scoped=true&"
import script from "./RouteErrorTooltip.vue?vue&type=script&lang=js&"
export * from "./RouteErrorTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72eb1140",
  null
  
)

export default component.exports